import { Box, Container, Grid, Typography, DownloadButtons } from 'src/components';
import { useIsMobile } from 'src/hooks';

import finalCTAImage from 'src/assets/alaska.jpg'; 

const FinalCTA = () => {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ bgcolor: '#f2f5f7', py: 4 }}>
      <Container>
        <Grid container spacing={4} alignItems="center" columns={2}>

          <Grid size={isMobile ? 2 : 1}>
            <Box
              component="img"
              src={finalCTAImage}
              alt="Adventure awaits"
              sx={{
                width: '100%',
                borderRadius: 3,
                boxShadow: 3,
                maxHeight: '400px'
              }}
            />
          </Grid>

          <Grid size={isMobile ? 2 : 1}>

            <Typography variant={isMobile ? "h3" : "h2"} fontWeight={600} gutterBottom>
              Ready to hit the road?
            </Typography>

            <Typography variant="h5" sx={{ mb: 1 }}>
              Start your Pan-American journey today with PanAm Explorer.
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
              <DownloadButtons displayInlineOnMobile={true} />
            </Box>

          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FinalCTA;
